import axiosInstance from '@/core/api'
import type { paths } from '@/schema'

type GetOtpProvidersResponse =
	paths['/api/admin/otp-provider']['get']['responses']['200']['content']['application/json']
type GetOtpProviderResponse =
	paths['/api/admin/otp-provider/{id}']['get']['responses']['200']['content']['application/json']
type GetActiveOtpProviderResponse =
	paths['/api/admin/otp-provider/active']['get']['responses']['200']['content']['application/json']
type CreateOtpProviderBody =
	paths['/api/admin/otp-provider']['post']['requestBody']['content']['application/json']
type CreateOtpProviderResponse =
	paths['/api/admin/otp-provider']['post']['responses']['201']['content']['application/json']
type UpdateOtpProviderBody =
	paths['/api/admin/otp-provider/{id}']['put']['requestBody']['content']['application/json']
type UpdateOtpProviderResponse =
	paths['/api/admin/otp-provider/{id}']['put']['responses']['200']['content']['application/json']

export class OtpProviderService {
	static async getOtpProviders(): Promise<GetOtpProvidersResponse> {
		const { data } = await axiosInstance.get<GetOtpProvidersResponse>(
			'/admin/otp-provider',
		)
		return data
	}

	static async getOtpProvider(id: string): Promise<GetOtpProviderResponse> {
		const { data } = await axiosInstance.get<GetOtpProviderResponse>(
			`/admin/otp-provider/${id}`,
		)
		return data
	}

	static async getActiveOtpProvider(): Promise<GetActiveOtpProviderResponse> {
		const { data } = await axiosInstance.get<GetActiveOtpProviderResponse>(
			'/admin/otp-provider/active',
		)
		return data
	}

	static async createOtpProvider(
		body: CreateOtpProviderBody,
	): Promise<CreateOtpProviderResponse> {
		const { data } = await axiosInstance.post<CreateOtpProviderResponse>(
			'/admin/otp-provider',
			body,
		)
		return data
	}

	static async updateOtpProvider(
		id: string,
		body: UpdateOtpProviderBody,
	): Promise<UpdateOtpProviderResponse> {
		const { data } = await axiosInstance.put<UpdateOtpProviderResponse>(
			`/admin/otp-provider/${id}`,
			body,
		)
		return data
	}

	static async deleteOtpProvider(id: string): Promise<void> {
		await axiosInstance.delete(`/admin/otp-provider/${id}`)
	}
}
